export const LOAD_APP = 'LOAD_APP';
export const LOAD_APP_SUCCEEDED = 'LOAD_APP_SUCCEEDED';

export const DATE_CHANGED = 'DATE_CHANGED';

export const SET_BOOKINGS_FETCH_RANGE = 'SET_BOOKINGS_FETCH_RANGE';
